import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "member-member-detail-body",
  templateUrl: "./member-detail-body.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberDetailBodyComponent {

}
